exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#userName[data-v-2efa8082]{font-size:12px;color:#00b3c1;text-align:center;height:50px}#Logo[data-v-2efa8082]{text-align:center;height:60px}#title[data-v-2efa8082]{font-size:16px;font-weight:900;word-break:break-all}#context[data-v-2efa8082]{font-size:15px;height:50px;word-break:break-all}#info[data-v-2efa8082]{font-size:12px;color:gray}#count[data-v-2efa8082]{float:right;margin-right:10px}.vux-flexbox .vux-flex-row[data-v-2efa8082]{height:100px;border-bottom:1px solid gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2efa8082","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Index/Course/Recommend.vue
// module id = IQt3
// module chunks = 1